import { refundHoldModeValues } from '@/common/constants'

export const buildPutRefundOnHoldPayload = ({ mode, delayDays, reason }) => {
  return {
    mode,
    delay_days: mode === refundHoldModeValues.delayByDays ? Number(delayDays) : null,
    reason: reason.trim(),
  }
}
